import type React from "react";

import { cn } from "../../../utils";
import { Text } from "../Text";

export const Error = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <Text
      size="sm"
      className={cn("font-normal leading-5 text-red-500", className)}
    >
      {children}
    </Text>
  );
};
